import { useState, useEffect } from "react";
import axios from "axios";
import { useCookies } from "react-cookie";
import { Button, Dropdown, DropdownItem, Table, TableBody, TableCell, TableHead, TableHeaderCell, TableRow, TextInput } from "@tremor/react";
import { ArrowUpRightIcon } from "@heroicons/react/24/outline";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../Dialog";
import { Input } from "../ui/Input"


import { Prices } from "../../interfaces/FinanceInterface";

export default function PricesTableComponent() {
  const [cookies] = useCookies(["mazelog-user"]);
  const token = cookies["mazelog-user"]?.token_data?.access_token;
  const orgId = cookies["mazelog-user"]?.organization_data?.id_org;

  const [requested, setRequested] = useState(false);
  const [prices, setPrices] = useState<Prices[]>([]);
  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState<Prices>({
    title: "",
    type: "",
    meli_ship_value: 0,
    ecom_ship_value: 0,
    shopee_ship_value: 0,
    collect_value: 0,
    status: true,
    org_id: 0,
  });

  // Buscar os preços na API
  const handleSubmit = () => {
    const baseURL = process.env.REACT_APP_MAZELOG_SYSTEM_BASE_URL;
    const oauth = "Bearer " + token;
    axios
      .get(`${baseURL}/prices/?org_id=${orgId}`, { headers: { accept: "application/json", Authorization: oauth } })
      .then((res) => {
        if (res.data != null) {
          setPrices(res.data.results);
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    if (!requested) {
      handleSubmit();
      setRequested(true);
    }
  }, [requested]);

  // Abrir diálogo para criar ou editar
  const openDialog = (price: Prices | null = null) => {
    if (price) {
      setFormData(price);
    } else {
      setFormData({
        title: "",
        type: "",
        meli_ship_value: 0,
        ecom_ship_value: 0,
        shopee_ship_value: 0,
        collect_value: 0,
        status: true,
        org_id: orgId,
      });
    }
    setIsOpen(true);
  };

  // Atualizar estado dos inputs
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Salvar os dados (pode ser ajustado para chamar API)
  const handleSave = () => {
    console.log("Dados salvos:", formData);
    
    const body = {
      ...formData
    }

    const baseURL = process.env.REACT_APP_MAZELOG_SYSTEM_BASE_URL;
    const oauth = "Bearer " + token;
    axios.post(
      `${baseURL}/prices/`,
      body,
      { headers: { accept: "application/json", Authorization: oauth } })
      .then(async (res)  => {
        await handleSubmit()
      })
      .catch((err) => console.log(err));
    setIsOpen(false);
  };

  const handleDelete = () => {
    const baseURL = process.env.REACT_APP_MAZELOG_SYSTEM_BASE_URL;
    const oauth = "Bearer " + token;
    axios.post(
      `${baseURL}/prices/remove?obj_id=${formData._id}`,
      // {obj_id: formData._id},
      { headers: { accept: "application/json", Authorization: oauth } })
      .then(async (res)  => {
        await handleSubmit()
      })
      .catch((err) => console.log(err));
    setIsOpen(false);
  };

  return (
    <div>
      <Button className="FilterButton align-top t-0 mb-4 h-full" onClick={() => openDialog()}>
        Criar Tabela de Preço
      </Button>
      <Table>
        <TableHead>
          <TableRow>
            <TableHeaderCell className="text-left">Título</TableHeaderCell>
            <TableHeaderCell className="text-left">ID</TableHeaderCell>
            <TableHeaderCell className="text-left">Tipo</TableHeaderCell>
            <TableHeaderCell className="text-left">Status</TableHeaderCell>
            <TableHeaderCell className="text-left">Abrir</TableHeaderCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {prices.map((price) => (
            <TableRow key={price._id}>
              <TableCell>{price.title}</TableCell>
              <TableCell>{price._id}</TableCell>
              <TableCell>{price.type}</TableCell>
              <TableCell>{price.status ? "Ativo" : "Inativo"}</TableCell>
              <TableCell>
                <Button onClick={() => openDialog(price)} className="OpenOrderBtn" icon={ArrowUpRightIcon} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* Dialog de criação/edição */}
      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent className="sm:max-w-lg  p-6">
          <DialogTitle>{formData._id ? "Editar Tabela de Preços" : "Criar Tabela de Preços"}</DialogTitle>
          
          <div className="grid grid-cols-2 gap-4 mt-4 mb-8 space-y-4">
            <div className="mt-4">
              <label>Título</label>
              <TextInput name="title" value={formData.title} onChange={handleChange} placeholder="Título" />
            </div>

            <div>
              <label>Tipo</label>
              <Dropdown
                className="max-w-md"
                value={formData.type}
                onValueChange={(value) =>
                  setFormData((prev) => ({
                    ...prev,
                    type: value,
                  }))
                }
                placeholder="Selecione o tipo"
              >
                <DropdownItem value="CLIENT" text="Cliente" />
                <DropdownItem value="TRANSPORTER" text="Transportador" />
              </Dropdown>
            </div>
            <div>
              <label>Valor Mercado Livre</label>
              <input className="InputPrimary" name="meli_ship_value" type="number" value={formData.meli_ship_value} onChange={handleChange} placeholder="Valor Mercado Livre" />
            </div>
            
            <div>
              <label>Valor E-Commerce</label>
              <input className="InputPrimary" name="ecom_ship_value" type="number" value={formData.ecom_ship_value} onChange={handleChange} placeholder="Valor E-commerce" />
            </div>
            
            <div>
              <label>Valor Shopee</label>
              <input className="InputPrimary" name="shopee_ship_value" type="number" value={formData.shopee_ship_value} onChange={handleChange} placeholder="Valor Shopee" />
            </div>
            
            <div>
              <label>Valor de Coleta</label>
              <input className="InputPrimary" name="collect_value" type="number" value={formData.collect_value} onChange={handleChange} placeholder="Valor de Coleta" />
            </div>
          </div>
            
            <DialogFooter>
              <Button className="bg-red-600 border-red-600 h-full" onClick={handleDelete}>Deletar</Button>

              <Button className="FilterButton h-full" onClick={handleSave}>Salvar</Button>

              <DialogClose asChild>
                <Button className="ButtonSecondary h-full">Fechar</Button>
              </DialogClose>
            </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
